import script from "./elements-audit-log.vue?vue&type=script&setup=true&lang=js"
export * from "./elements-audit-log.vue?vue&type=script&setup=true&lang=js"

import "./elements-audit-log.vue?vue&type=style&index=0&id=a76cc3b0&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a76cc3b0"]])

export default __exports__